import { render, staticRenderFns } from "./InfoNoteTooltip.vue?vue&type=template&id=70f717c0&scoped=true&"
import script from "./InfoNoteTooltip.vue?vue&type=script&lang=js&"
export * from "./InfoNoteTooltip.vue?vue&type=script&lang=js&"
import style0 from "./InfoNoteTooltip.vue?vue&type=style&index=0&id=70f717c0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f717c0",
  null
  
)

export default component.exports